export const MAINTENANCE = {
  development: [],
  staging: [],
  production: []
};
